import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { useEffect } from 'react'
import { ErrorLayout } from './ErrorLayout'
import NO_WORK_EXPERIENCE from './assets/no_work_experience.png'
import { NoWorkExperienceImage } from './styles'
import { ErrorComponentProps } from './types'

export const NoWorkExperience = ({ CustomContainer, analyticEventsLabel }: ErrorComponentProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    trackInternalEvent('show_missing_error', {
      label: analyticEventsLabel,
      missing_info: 'work_experience',
    })
  }, [analyticEventsLabel])

  return (
    <ErrorLayout
      CustomContainer={CustomContainer}
      Images={<NoWorkExperienceImage src={NO_WORK_EXPERIENCE} alt="no_work_experience" />}
      translationKey="no_work_experience"
      onClick={() => {
        trackInternalEvent('view_profile_editor', { label: 'recommended_jobs' })
        navigate(
          '/career-profile/edit?section=workExperiences&returnUrl=/job-search?view=recommendation',
        )
      }}
    />
  )
}
